import React from 'react';
import { Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import ExpenseTable2 from './ExpenseTable2';



const ConstructionExpenses = () => {

    return (
        <Container>
            <Typography variant='h2' align='center'> Foundation Expenses </Typography>
            <Button size='large' variant='contained' color='primary' component={Link} to='/AddConstructionExpenses'> Add Expenses </Button>
            <ExpenseTable2/>
            {/* <ExpenseTable/> */}
        </Container>

    );
};

export default ConstructionExpenses;